import script from "./DesingFormulario.vue?vue&type=script&setup=true&lang=js"
export * from "./DesingFormulario.vue?vue&type=script&setup=true&lang=js"

import "./DesingFormulario.vue?vue&type=style&index=0&id=6fb0d88c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb0d88c"]])

export default __exports__